import React from 'react';
import PropTypes from 'prop-types';
import { Form, Tooltip } from '@syneto/compass-react';

/*
 * The "Remote support" cell of the Maintenance types table. The row itself opens the edit modal on
 * click, so the switch stops the click where it lands. While the flag is unknown (still loading, or
 * the server did not list this type) the switch is disabled rather than shown off: one click on a
 * wrong value would save it.
 */
const RemoteSupportToggle = ({ maintenancePlan, allowed, saving, disabled, onToggle }) => {
	const known = typeof allowed === 'boolean';
	const name = maintenancePlan.synetoInternalName ?? maintenancePlan.customerFacingName ?? maintenancePlan.id;
	const tooltip = known
		? `Remote support ${allowed ? 'on' : 'off'} for ${name}`
		: 'The remote support setting of this type could not be loaded';

	return (
		<div className="d-inline-block" onClick={(event) => { event.stopPropagation(); }}>
			<Tooltip text={tooltip} placement="top">
				<span className="d-inline-block">
					<Form.Switch
						id={`remote-support-${maintenancePlan.id}`}
						aria-label={`Remote support for ${name}`}
						checked={Boolean(allowed)}
						disabled={!known || saving || disabled}
						onChange={() => { onToggle(maintenancePlan.id); }}
					/>
				</span>
			</Tooltip>
		</div>
	);
};

RemoteSupportToggle.propTypes = {
	maintenancePlan: PropTypes.object.isRequired,
	allowed: PropTypes.bool,
	saving: PropTypes.bool,
	disabled: PropTypes.bool,
	onToggle: PropTypes.func.isRequired
};

export default RemoteSupportToggle;
